__turbopack_context__.v({
  "card": "Reasons-module__WbgYBa__card",
  "cardBody": "Reasons-module__WbgYBa__cardBody",
  "cardCopy": "Reasons-module__WbgYBa__cardCopy",
  "cardSubtitle": "Reasons-module__WbgYBa__cardSubtitle",
  "cardTitle": "Reasons-module__WbgYBa__cardTitle",
  "cardTop": "Reasons-module__WbgYBa__cardTop",
  "imageSlot": "Reasons-module__WbgYBa__imageSlot",
  "reasonsList": "Reasons-module__WbgYBa__reasonsList",
  "reasonsSection": "Reasons-module__WbgYBa__reasonsSection",
  "stickyItem": "Reasons-module__WbgYBa__stickyItem",
});
